import React from 'react';
import { Step } from 'components/SteppedModal';
import useSocialShareModalFooter from 'containers/SocialShareModal/SocialShareModalFooter';
import { FacebookSocialShareStep } from '../../types';
import FacebookPostComposerStep from './FacebookPostComposerStep';

export type UseFacebookPostComposerStepConfig = {
  onShare: () => void;
};

export default function useFacebookPostComposerStep({
  onShare,
}: UseFacebookPostComposerStepConfig): Step<FacebookSocialShareStep> {
  const footerConfig = useSocialShareModalFooter({
    onShare,
  });

  return {
    ...footerConfig,
    id: 'composer',
    component: <FacebookPostComposerStep />,
  };
}
